// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3kdts","boxTitle":"Qualiphy_boxTitle__2NtOh","box":"Qualiphy_box__3YZ3C","toggleWrap":"Qualiphy_toggleWrap__nBPOO"};